










import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
    name: "AddPartnerButton"
})
export default class AddPartnerButton extends Vue {
    @Prop({ default: false }) hasStageFile: boolean;
}
